// Insert a knowledge-base article into the `documents` table with
// folder='knowledge-base'. Used by meet's applySuggestion when the
// transcript extraction routes to the `knowledge_base` bucket.
//
// We reuse the `documents` table (which already has folder-based
// categorization + a matching fetch in documentsFetch) rather than
// introducing a separate kb_articles table, so KB entries automatically
// show up in /documents when filtered by the knowledge-base folder.
//
// migrated 2026-04-27 to SDK route workspaceProject.documents
import { getSDK } from '../../../shared/functions/sdk.js'

export const saveKbArticle = async function ({
  id = null,
  title = 'Untitled article',
  category = 'general',
  summary = '',
  content = ''
} = {}) {
  const root = this.state.root
  const row = {
    title,
    folder: 'knowledge-base',
    type: 'doc',
    author: root.currentUserEmail || 'Unknown',
    // Populate `author_email` for Phase E ownership-gated RLS (0069).
    // Equivalent to `author` in practice — `author` already stores emails
    // in this schema — but the new RLS policies cite `author_email`.
    author_email: root.currentUserEmail || null,
    summary: summary || '',
    // documents.content is JSONB in some schemas; wrap the plain text
    // extraction as a single text block so the editor can render it.
    content: typeof content === 'string'
      ? { blocks: [{ type: 'text', text: content }] }
      : (content || { blocks: [] })
  }
  let data = null
  try {
    data = id != null
      ? await getSDK().execute('workspaceProject.documents', 'update',
          { id, payload: row })
      : await getSDK().execute('workspaceProject.documents', 'create',
          { payload: row })
  } catch (err) {
    console.error('[saveKbArticle] write failed', err?.message || err)
    return null
  }
  if (!data?.id) {
    console.error('[saveKbArticle] write returned no id')
    return null
  }
  const existing = root.documents || []
  const merged = {
    id: data.id,
    title: data.title || title,
    folder: data.folder || 'knowledge-base',
    type: data.type || 'doc',
    author: data.author || '',
    updatedAt: new Date().toISOString().slice(0, 10),
    summary: data.summary || summary,
    content: data.content || row.content
  }
  const next = existing.some((r) => r.id === data.id)
    ? existing.map((r) => (r.id === data.id ? merged : r))
    : [merged, ...existing]
  root.update({ documents: next })
  return data.id
}
